// Helpers generici
var modalHandler = null;
var viewInfoBox = false;
class Utils {
  modalOpened(id) {
    if (modalHandler != null) {
      this.removeModalHandler();
    }

    //il contenitore della modale aperta
    let modalContainer = document.querySelector(id);

    //aggiunge un listener al focus sul documento
    document.addEventListener(
      "focusin",
      (modalHandler = function(event) {
        //calcola se l'evento è scaturito da un elemento interno alla modale
        let isFocusInsideModal = modalContainer.contains(event.target);

        //se l'evento non è scaturito da un elemento interno alla modale
        if (!isFocusInsideModal) {
          //previene comunque il comportamento di default
          event.preventDefault();

          let focusable = modalContainer.querySelectorAll(
            "input,a,button:enabled"
          );

          //se ci sono elementi a cui dare il focus (dovrebbe sempre essere true)
          if (focusable.length) {
            //prende il primo elemento, l'ultimo elemento e memorizza se viene premuto shift
            let first = focusable[0];
            let last = focusable[focusable.length - 1];
            let shift = event.shiftKey;

            //se stato premuto shift
            if (shift) {
              //dà il focus all'ultimo elemento
              last.focus();
            } else {
              //dà il focus al primo elemento
              first.focus();
            }
          }

          return;
        }
      })
    );
  }

  removeModalHandler() {
    document.removeEventListener("focusin", modalHandler);
  }

  handleTabNavigation(event, id) {
    let focusable = document
      .querySelector(id)
      .querySelectorAll("input,a,button:enabled");

    //se ci sono elementi a cui dare il focus (dovrebbe sempre essere true)
    if (focusable.length) {
      //prende il primo elemento, l'ultimo elemento e memorizza se viene premuto shift
      let first = focusable[0];
      let last = focusable[focusable.length - 1];
      let shift = event.shiftKey;

      //se l'evento è scaturito da un elemento interno della dialog
      if (this.nodelistContains(focusable, event.target)) {
        //se si tratta del primo elemento ed è stato premuto shift
        if (shift && event.target === first) {
          event.preventDefault();
          //dà il focus all'ultimo elemento
          last.focus();
        }
        //se si tratta dell'ultimo elemento e non è stato premuto shift
        else if (!shift && event.target === last) {
          event.preventDefault();
          //dà il focus al primo elemento
          first.focus();
        }
      } else {
        //se l'evento non scaturisce da un elemento che si trova all'interno della dialog
        event.preventDefault();

        if (shift) {
          last.focus();
        } else {
          first.focus();
        }
      }
    }
  }

  nodelistContains(nodelist, obj) {
    if (-1 < Array.from(nodelist).indexOf(obj)) return true;

    return false;
  }
}

export default Utils;
